module.exports = __webpack_public_path__ + "static/img/right-num-row-5.152ce7d4.png";